import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MyService } from 'src/app/shared/services/myservice';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExternalService } from 'src/app/shared/services/external.service';
@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrl: './accounts.component.scss'
})
export class AccountsComponent implements OnInit {
  @ViewChild('fileWarning', { static: true }) fileWarning: ElementRef<any>
  public checkoutForm: UntypedFormGroup;
  constructor(private router: Router, private myService: MyService, private toastrService: ToastrService,
    private fb: UntypedFormBuilder, private modalService: NgbModal, private externalService: ExternalService,) {


    this.checkoutForm = this.fb.group({
      name: [null, [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
      phone: [null, [Validators.required, Validators.pattern('[0-9]+')]],
      enquiry: [null, [Validators.required, Validators.minLength(10)]],

    })


  }

  Enquiry: any = {
    name: '',
    phone: null,
    enquiry: '',
    imgUrl: ''
  }

  ngOnInit(): void {
    this.filevalue = 0
    this.Enquiry = {
      name: '',
      phone: null,
      enquiry: '',
      imgUrl: ''
    }
  }
  validateAlphabeticInput(event: KeyboardEvent) {
    const keyCode = event.keyCode;
    const allowedKeyCodes = [8, 9, 32];
    if (!((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || allowedKeyCodes.includes(keyCode))) {
      event.preventDefault();
    }
  }

  validateNumericInput(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const inputChar = event.key;

    if (!allowedKeys.includes(inputChar)) {
      event.preventDefault();
    }
  }

  yourOrders() {
    this.router.navigate(['/shop/order/management/']);
  }

  yourAddress() {
    this.router.navigate(['/shop/addcustomer/']);
  }

  yourwishlist() {
    this.router.navigate(['/shop/wishlist/']);
  }

  hidecard: boolean = false
  Contact() {
    this.hidecard = true
  }
  backcard() {
    this.hidecard = false
  }
  storeList() {
    this.router.navigate(['/pages/StoreList'], { queryParams: { name: 'StoreList' } });
  }
  couponLIst() {
    this.router.navigate(['/pages/Rewards'], { queryParams: { name: 'Coupons' } });

  }

  logout() {
    localStorage.removeItem('customerid');
    localStorage.removeItem('denglu');

    localStorage.removeItem('productId');
    localStorage.removeItem('prdname');
    localStorage.removeItem('myApp_CartCount');
    localStorage.removeItem('name');
    // localStorage.removeItem('myApp_CartCount');

    localStorage.removeItem('wishlistItems');
    localStorage.removeItem('cartItems');
    localStorage.removeItem('secid');
    localStorage.removeItem('fav');





    // console.log('REMOVE', localStorage.removeItem('customerid'));

    localStorage.setItem('mypg', '5');
    this.myService._pageId.next(5);
    this.router.navigateByUrl('home/fashion')

    if (this.router.url == 'home/fashion') {
      location.reload()
    }

    // console.log('denglu');

    if (localStorage.getItem('denglu')) {
      this.toastrService.success('Login', ' Login Successfully!')
    } else {
      this.toastrService.success('LogOut', ' LogOut Successfully!')
    }
  }

  fileToUpload: any
  imageUrl: any = 'assets/images/Extra/screen.jpg'
  filevalue = 0
  handleFileInput(file: FileList) {
    // console.log(file)
    if (file[0].size <= 10458000) {
      this.fileToUpload = file.item(0)
      let reader = new FileReader()
      // console.log(reader)
      reader.onload = (event: any) => {
        // console.log(event)
        this.imageUrl = event.target.result
        this.Enquiry.imgUrl = this.imageUrl
        // console.log(this.Enquiry.imgUrl)
        this.filevalue = 0
      }
      reader.readAsDataURL(this.fileToUpload)
    } else {
      this.toastrService.warning('Cannot Upload, File is Larger!')
      this.filevalue = 1
    }

  }



  saveEnquiry() {
    // console.log(this.Enquiry)
    const custid = localStorage.getItem('customerid')
    this.Enquiry.custId = custid
    if (this.filevalue == 0) {
      // console.log(this.Enquiry)
      this.externalService.AddContactEnq(this.Enquiry).subscribe(response => {
        // console.log(response)
      })
    } else {
      this.modalService.open(this.fileWarning, { centered: true, size: 'l' });
    }
  }


}
